import React from "react";
import * as yup from "yup";
import ResetPasswordForm from "./ResetPasswordForm";
import BrandLogo from "../../assets/sidebar-nav/brand-logo.svg";
import BaseWrapper from "../../components/ui/BaseWrapper";
import BaseInnerWrapper from "../../components/ui/BaseInnerWrapper";

const ResetPassword = () => {
  return (
    <BaseWrapper>
      <BaseInnerWrapper className="h-full lg:py-16 py-8 2xl:mx-72 xl:mx-24 lg:mx-64 mx-0 xl:px-[70px] px-[0px]">
        <div className="lg:border border-zinc-300 rounded-lg lg:py-16 lg:px-10  flex flex-col items-center max-w-[500px] mx-auto">
          <div className="flex flex-col justify-center items-center cursor-default w-full ">
            <img src={BrandLogo} width={110} />
            <ResetPasswordForm />
          </div>
        </div>
      </BaseInnerWrapper>
    </BaseWrapper>
  );
};

export default ResetPassword;
